import sortBy from 'lodash/sortBy';

import { DeviceOfferDetail, Price, ProductDetailPromotions } from '../typings';

export const constructPriceAttributes = (price: Price | DeviceOfferDetail) => ({
  itemBasePrice: price?.basePrice?.toString(),
  itemOneOffCost:
    price?.priceType === 'OneTime' ? price?.basePrice?.toString() : '0.00',
  itemRecurringCost:
    price?.priceType === 'Recurring' ? price?.basePrice?.toString() : '0.00',
});

export const constructPromotionAttributes = (
  promotions: ProductDetailPromotions | DeviceOfferDetail['promotions'],
) => ({
  promoMessage: promotions
    ?.filter((promotion) => promotion?.productType === 'DEAL')
    .map((promo) => promo.shortDescription)
    .join(','),
  promoTag: promotions
    ?.filter((promotion) => promotion?.productType === 'MARKETING')
    .map((promo) => promo.shortDescription)
    .join(','),
});

export const sortAttributesByOrder = <T>(attributes: T[]): T[] => {
  return sortBy(attributes, 'sortOrder');
};
